import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { history }  from '../routers/AppRouter'
import {Helmet} from 'react-helmet';
// import   jwt from 'jsonwebtoken';
// import { FooterSection } from './FooterSection'; 
import   format from 'date-fns/format';
import   isEqual from 'date-fns/isEqual';
import   PicGetRequest  from '../apis/PicGetRequest';
// import   PicPutRequest  from '../apis/PicPutRequest';
// import { TextButtonGroup } from './buttons/TextButtonGroup';
import   PicInvitationContribStatus from './PicInvitationContribStatus';
import  { PicInvitationHelpStatus } from './PicInvitationHelpStatus';
import  PicInvitationAttendeeStatus from './PicInvitationAttendeeStatus';
// import { ErrorMessage } from './ErrorMessage';
import { SimpleButton } from './buttons/SimpleButton';
import  getAppConfigParm  from '../config/AppConfig';
import Footer from "../components/common/Footer";
import  VisibilityWrapper      from "../components/common/VisibilityWrapper";
import  { HorizRule }     from  "../components/decorators/HorizRule";
import { displayAd } from './advertisements/helpers/displayAd';
import  { prtStart, prtEnd, prtInput, prtStep, prtVar, prtOutput, prtErr } from "../utils/prt"; 
// import   AppConfig from '../config/AppConfig';
// import { GoogleAdInit } from './advertisement/GoogleAdInit';


// This another variation of the PicInvitation Page. This version provides 
// a summary view. This version is read only. There are no prompts (eg Attending Yes/No),
// buttons, or input fields to enter quantity. This page has removed the logic
// to detect whether user is internal or external, since its always rendered internally.
// It does have logic to detect whether the event it showing status for is the current
// user's event or whether event being rendered is an event the current user is Invited To.


// ***************************************************************************
// Component process
// When component mounts the following occurs:
//   - Make api call to get eventObj and saves event info in local state
// In the render():
//   - Component renders event details
//   - It also renders a prompt when user responds with yes and a prompt for no
//   - Provides user option to Pitch In.
// ***************************************************************************

var trace = "true";
var compName = "PicListStatuses";


const TopBorder = () => (
    <div className="pic-event-tb">Event Status</div>
);

const renderDateAndTime = (startDate, startTime, endDate, endTime) => { 

    /* set flag as to whether startdate and enddate are the same */
    let isStartAndEndDateEqual = isEqual(startDate, endDate);

    /* construct Jsx for when start and end dates are same */
    let sameDayJsx = (
        <div>
            <span>Date:&nbsp;</span> <span className="invites-event-field">{`${format(startDate, 'MMMM, dd, YYYY')}`} </span>
            &nbsp;&nbsp;&nbsp;
            <span className="invites-event-date">{`${format(startTime, 'hh:mm a')} - ${format(endTime,'hh:mm a')}`}</span>
        </div>
    )

    /* construct Jsx for when start and end dates are different */
    let differentDaysJsx = (
        <div className="pic-event-detail-sectionx" style={{display: 'flex', flexDirection: 'column'}}>
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <div  className="pic-event-label">Date:</div> 
                <div className="invites-event-field">{`${format(startDate, 'MMM, dd, YYYY')} ${format(startTime,'hh:mm a')}`}</div>
            </div>
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <div className="pic-event-label">To :&nbsp;</div> 
                <div className="invites-event-field">{`${format(endDate, 'MMM, dd, YYYY')} ${format(endTime, 'hh:mm a')}`}</div>
            </div>
        </div>
    )

    /* render jsx based on condition */
    if (isStartAndEndDateEqual) {
        return sameDayJsx;
    } else {
        return differentDaysJsx;
    }
}

/* Renders all the information about the event */
const eventDetailSection = (title, location, startDate, startTime, endDate, endTime,  organizer, message, clearPage) =>  {
    // let errormsg = this.state.formError || '';
    //trace && prtStart(compName, 'eventDetailSection');
    //trace && prtInput('title', title);
    //trace && prtInput('location', location);
    //trace && prtInput('message', message);
    //trace && prtInput('clearPage', clearPage);

    return (
        <div>
            <div className="pic-event-detail-section">
                <div className="pic-event-title">{title}</div> 
                <HorizRule color="#95A5A6" pctWidth="95%" thickness=".1rem" mb="2rem" />
                <div style={{display: 'flex'}}>
                    <div className="pic-event-label">Organizer:</div>
                    <div className="invites-event-field">{organizer} </div>
                </div>

                <div>{renderDateAndTime(startDate, startTime, endDate, endTime)}</div>

                <div className="rc-flex-container-r2c">
                    <div className="pic-event-label">Location:&nbsp;</div>
                    <div className="invites-event-field">{location}</div>
                </div>                
            </div>
            {!clearPage && 
                <div className="pic-event-detail-section">
                    <div className="pic-event-label">Message:&nbsp;</div>
                    <div className="pic-event-message">{message}</div>
                </div>
            }
        </div>
    )
}

// This page uses the PicEventsTable component. This a flex table component that 
// takes as props an array of rows (each row has array of column/cells) that allows for a 
// fixed number of columns (eg 3 or 4). Note that the contents of each cell or column
// in the flex table can be text or jsx. The mapping of the data to the JSX structures
// is done in the componentDidMount lifecycle method.
export class PicListStatuses extends React.Component { 

    constructor(props) {
        super(props);

        this.state = {
            eventObj: {},
            attendees: [],
            contributions: [],
            helpingHandsList: [],
            invitedToList: [],
            inviteeUserName: "",
            isMyEvent: true,
            panel0IconOpen:    false,   /* false means icon close position, true is open position*/
            panel1IconOpen:    false,   /* false means icon close position, true is open position*/
            panel2IconOpen:    false,   /* false means icon close position, true is open position*/
            displayLists:  false,
            clearPage:     false,   /* set to true when user clicks pitch in button. Clears screen to show lists */
            formError: ''
        }
    }

    //*************************************************************************
    // Lifecycle methods
    //*************************************************************************

    // Initialize event list
    componentDidMount = () => {
        //trace && prtStart(compName, 'componentDidMount');
        // trace && prtInput('props', JSON.stringify(this.props,null,2))

        let self = this;

        /* Initialize variables used with the chain of promises in componentDidMount*/
        let eventObj = {};
        let event_id = '';
        let contributions = [];
        let helpingHandsList = [];
        let attendees =  [];
        let token = '';
        let currentUserEmail = '';
        let currentUserName = '';
        let inviteeUserName = '';
        let contrib_uri = '';
        let get_event_uri = '';
        let get_helplist_uri = '';
        let get_participants_uri = '';
        let isMyEvent = true;
        
        //trace && prtStep("Initialize variables before kicking off promise chain")
        /* Get event id passed in from Dashboard. Provided when user clicks on Dashboard Event name  */
        event_id = this.props.match.params.id;
        //trace && prtVar('event_id', event_id, 'Route');

        /* get user cuurent user's token */
        token  = this.props.auth.token;
        //trace && prtVar('token', token);

        /* get currentUserEmail */
        currentUserEmail = this.props.auth.user.email;
        //trace && prtVar('currentUserEmail', currentUserEmail);

        /* Determine if this is current user's Event, or an "Event Invited To" by someone else. 
           If this an "Event Invited To", update local state with invitedToList from redux/store */
        isMyEvent = this.props.picapp.filters.eventListFilter === "Events Invited To" ? false : true;
        this.setState({invitedToList: this.props.event.invitedToList, isMyEvent})
        //trace && prtVar('isMyEvent', isMyEvent);
    
        /* set up resource uri's for contributions, event info, and help items */
        contrib_uri   = `/event/${event_id}/contributions/`;       /* private route */
        get_event_uri = `/event/${event_id}`; /* No need to use composite service as we can get name of logged in user from redux store */
        get_helplist_uri = `/event/${event_id}/todos`
        get_participants_uri = `/event/${event_id}/participants`
        
        /* Fire API Request to get Event info along with participant name; Note this public route is used for both internal and external requests  
           For external requests, the token is not set */
       let step = "notStarted";

       /* set up get request for event info */
       //trace && prtStep("Get Event By Id")
       let getRequest = new PicGetRequest("GetEventById")    
            .setUserId(currentUserEmail)
            .setUri(get_event_uri)
            .setLogTrace(false)
            .setAuthToken(token);  /* set token for internal request */
            step = "getEvent";    /* This step gets event info along with participant name from  participants collection */         
        /* execute get request for event info */
        getRequest.exec().then((response) => {     
            //trace && prtOutput('GetEventyById', 'response.data', `${JSON.stringify(response.data,null,2)}`);          
            eventObj = response.data || {};
            eventObj.currentUserEmail = currentUserEmail;  /* add currentUserEmail property to object */
            eventObj._id = event_id;

            /* set currentUserName for My Event and set inviteeUserName for Invited Event (or set to empty string) */
            currentUserName = this.props.auth.user.firstname + ' ' + this.props.auth.user.lastname;
            inviteeUserName = this.getInviteeNameFromInvitedToList(event_id); /* get invitee name for EventsInvitedTo, otherwise default to "" */
            eventObj.currentUserName = currentUserName;  /* add current user name from auth state to eventObj */
            eventObj.inviteeUserName = inviteeUserName;  /* add inviteeuserName from invitedToList state to eventObj. Used for an EventsInvitedTo event */

            // self.setState({eventObj, currentUserEmail, currentUserName});
            self.setState({eventObj, inviteeUserName});

            /* set up get request to get participants as attendee list */
            //trace && prtStep("GetParticipants")
            let getParticipantsRequest = new PicGetRequest("GetParticipants")
            .setUserId(currentUserEmail)
            .setUri(get_participants_uri)
            .setLogTrace(false)
            .setAuthToken(token);  /* set token for internal request */ 
            step = "getParticipants";
            return getParticipantsRequest.exec()
        /* execute get request for contributions */    
        }).then ((response) => {
            //trace && prtOutput('GetParticipants ', 'response.data.participants', `${JSON.stringify(response.data.participants,null,2)}`); 
            let participantList = response.data.participants || [] ;
            attendees = this.mapParticipantDataToFlexTable(participantList);

            // this.setState({contributions, panel1IconOpen: true});
            this.setState({attendees});

            /* set up get request for contributions */
            //trace && prtStep("GetContributions")
            let getContributionsRequest = new PicGetRequest("GetContributions")
            .setUserId(currentUserEmail)
            .setUri(`${contrib_uri}`)
            .setLogTrace(false)
            .setAuthToken(token);  /* set token for internal request */
            step = "getContributions";
            return getContributionsRequest.exec()
        }).then ((response) => {
            //trace && prtOutput('GetParticipants ', 'response.data.items', `${JSON.stringify(response.data.items,null,2)}`); 
            let contribList = response.data.items || [] ;
            contributions = this.mapDataToFlexTable(contribList);
            this.setState({contributions});

            /* set up get request to for helping hands list */
            //trace && prtStep("getHelpingHandsList")
            let getHelpListRequest = new PicGetRequest("GetHelpList")
            .setUserId(currentUserEmail)
            .setUri(`${get_helplist_uri}`)
            .setLogTrace(false)
            .setAuthToken(token);  /* set token for internal request */
             step = "getHelpingHandsList";
            return getHelpListRequest.exec()
            /* execute request for helping hands list */
        }).then ((response) => {
            //trace && prtOutput('getHelpingHandsList ', 'response.data.todos', `${JSON.stringify(response.data.todos,null,2)}`); 
            let helpList = response.data.todos || [] ;
            // console.log("THIS IS HELP LIST BEFORE MAPPING TO FLEX TABLE");
            // console.log(helpList);
            helpingHandsList = this.mapHelpDataToFlexTable(helpList);
            // console.log("THIS IS HELP LIST MAPPED TO FLEX TABLE");
            // console.log(helpingHandsList);
            this.setState({helpingHandsList, panel2IconOpen: false});
        }).catch((error) => {
            //trace && prtErr(error); 
            let errorResponse = getRequest.getError();
            let errmsg = '';
            switch (step) {
                case "getEvent":
                    if (errorResponse.status === 404) {
                        errmsg = `NotFound: did not find participant email '${currentUserEmail}' for given event`
                    }
                    break;
                default: 
                    errmsg = `Oops: Encountered error ${error} in ${step} request for '${currentUserEmail}' for event ${event_id}`
            }
            self.setState({formError: errmsg})
        });
        //trace && prtEnd('PicListStatuses', 'componentDidMount')
    } /* end of component did mount */

    //*************************************************************************
    // Event Handlers
    //*************************************************************************

    /* this handler is used by ErrorMessage Component. When user clicks the X
     it clears the formError value and effectively closes the message box */
    clearErrorMessage = () => {
        this.setState({formError: ''})
    }

    /* Called by child component to raise error */
    handleRaiseError = (text) => {
        this.setState({formError: text});
    }
    
    /* This is fired when user clicks caret icon on the expansion panel0 bar */
    handleOnClickForPanel0 = () => {

        /* user clicked icon, therefore flip state */
        let panel0IconOpen = !this.state.panel0IconOpen

        /* makes sure 2 tables are not expanded at the same time. If panel1 is open when panel2 icon clicked,
           then close panel1 and panel0  */
        if (panel0IconOpen === true)  {  /* reset flag to hide message */
            this.setState({ panel0IconOpen: true, panel2IconOpen: false, panel1IconOpen: false})   
        } else if (panel0IconOpen === false) {
            this.setState({ panel0IconOpen: false})    
        }
    } 

    /* This is fired when user clicks caret icon on the expansion panel1 */
    handleOnClickForPanel1 = () => {

        /* user clicked icon, therefore flip state */
        let panel1IconOpen = !this.state.panel1IconOpen

        /* makes sure both tables are not expanded at the same time. If panel2 is open when panel1 icon clicked,
           then close it  */
        if (panel1IconOpen === true)  {  
            this.setState({panel1IconOpen: true, panel2IconOpen: false, panel0IconOpen: false })   
        } else if (panel1IconOpen === false) {
            this.setState({panel1IconOpen: false})    
        }
    } 

    /* This is fired when user clicks caret icon on the expansion panel2 bar */
    handleOnClickForPanel2 = () => {

        /* user clicked icon, therefore flip state */
        let panel2IconOpen = !this.state.panel2IconOpen

        /* makes sure both tables are not expanded at the same time. If panel1 is open when panel2 icon clicked,
           then close it  */
        if (panel2IconOpen === true)  {  /* reset flag to hide message */
            this.setState({ panel2IconOpen: true, panel1IconOpen: false, panel0IconOpen: false})   
        } else if (panel2IconOpen === false) {
            this.setState({ panel2IconOpen: false})    
        }
    } 
 
    /* when user clicks pitch in button; pitchInMode is set to true.  When this flag is set to true
       we hide the message section and everything underneath in order to show the two lists */
    // handleOnClickPitchInButton = () => {
    //     let { rsvpFlag } = this.state;  /* save current state of rsvp  flag */
    //     this.setState({ clearPage: true, displayLists: true, rsvpFlag });
    // }

    handleOnClickBackButton = () => {
        /* Go back by dynamically rendering first page where we do not clearPage or display lists */
        /* close all expansion panels */
        this.setState({  panel0IconOpen: false, panel1IconOpen: false, panel2IconOpen: false,}) 

        history.push("/dashboard");
        // this.setState({ clearPage: false, displayLists: false });
    }

 
    /* This is fired when changing contribution value. Cange is reflected in the contribution list in parent*/ 
    // handleChangeQuantity = (contributions) => {
    //     this.setState({contributions});
    // }
 
    //*************************************************************************
    // Utilities / or Help functions
    //*************************************************************************

    /* converts the contribution list from an array of objects to an array of array of items*/
    mapDataToFlexTable = (contributionList) =>  {
        let convertedArray = contributionList.map( (item) => {
            return   [item.contribution, item.quantity, parseInt(item.quantity,10), "button", item.contributors, "notUpdated"]
        }) 
        return convertedArray;
    }   

    /* converts help list items from an array of objects to an array of array of items*/
    mapHelpDataToFlexTable = (hhList) =>  {
        let hhListArray = hhList.map( (todo) => {
            return   [todo.todo, todo.peopleNeeded, "button", todo.participants, "notUpdated"]
        }) 
        return hhListArray;
    }   


     /* converts help list items from an array of objects to an array of array of items*/
     mapParticipantDataToFlexTable = (participants) =>  {
        let participantsArray = participants.map( (participant) => {
            // return   [participant.name, participant.email, participant.attend]
            return   [participant.name, participant.attend.toUpperCase()]
        }) 
        return participantsArray;
    }   

    /* Contributor list  is found as 4th item in table row . Created this help function so that
       in event it moves, I only need to change it in one place */
    getContributorList = (contributionList, rowIndex) => {
        return contributionList[rowIndex][4];
    }

    /* Get the Invitee's organizers name from invitedTolist referenced in local state. If this is one All My Events, return empty string */
    getInviteeNameFromInvitedToList= (event_id)  => {
        console.log(`>>>> getInviteeNameFromInvitedToList`);
        console.log(`    event_id passed in is: ${event_id}`);
        let inviteeUserName = "";
        if (!this.state.isMyEvent) {
            let eventInvitedToObj = this.state.invitedToList.find(invitedToEvent => invitedToEvent._id === event_id);
            inviteeUserName = eventInvitedToObj.name;
        }
        /* return name property off the eventObj found */
        // console.log(`    this is inviteeUserName: ${inviteeUserName}`);
        // return inviteeUserName ? inviteeUserName : "";
        return  inviteeUserName;
    }

    //*************************************************************************
    // Component render method
    //*************************************************************************
    render() {
        //trace && prtStart(compName, 'render()');
        // console.log("This is event ", this.state.eventObj);
        // console.log("This is contributions ", this.state.contributions);
        // let submitResponseButtonColor = this.state.pitchInButtonClickedOnce ? "" : "grey"

        let errormsg = this.state.formError || '';

        let { eventTitle, location, startDate, startTime, endDate, endTime, organizer, eventMessage, inviteeUserName } = this.state.eventObj;
        let { clearPage, panel0IconOpen, panel1IconOpen, panel2IconOpen } = this.state;

        /* get username form redux store */
        let userName = this.props.auth.user.firstname + ' ' + this.props.auth.user.lastname;

        /* Get the showAd directive from the AppConfig */
        let showAd = getAppConfigParm("showAd");
        let showSkyScraper = false;

        /* If no organizer, assign userName if it's My Event or assign inviteeUserName, if it's an Event I'm invited to */
        if (!organizer) {
            if (this.state.isMyEvent) {
                organizer = userName;
            } else {
                organizer = inviteeUserName;
            }
        }
       

        return (
            <div> 
                <Helmet>
                    <title>Event Stats</title>
                    <meta name="description" content="Event Stats" />
               </Helmet>
               <VisibilityWrapper show={showAd} contentType="advertisement">
                <div className="rc-flex-container-center-hv"  style={{borderTop: '1px solid #95A5A6'}}>
                    {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                    {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                    {displayAd("web-leader-board", "tablet", {marginTop: '1.3rem', marginBottom: '1.3rem'})}
                </div>
               </VisibilityWrapper>  
               <div className="app-container-invitation">    
                  <div className="pic-event-status-container"> 
                    <div className="pic-list-statuses-container">
                        <TopBorder />
                        <div style={{display: "flex", justifyContent: "center", marginTop: ".3rem"}}>
                        {/* <ErrorMessage text={errormsg} allowClose={true} clearError={this.clearErrorMessage} />  */}
                        </div>
                        {eventDetailSection(eventTitle, location, startDate, startTime, endDate, endTime, organizer, eventMessage, clearPage)}  
                        {!clearPage && (
                        <div style={{display: "flex", justifyContent: "center" }}>
                             <HorizRule color="#95A5A6" pctWidth="95%" thickness=".1rem" mb="2rem" />
                        </div>
                        )}
                        <div className="pic-event-submitbutton-container">
                            <SimpleButton  buttonText="Back" color="grey" onClickHandler={this.handleOnClickBackButton} />
                        </div>
                        <div className="pic-event-modifier-mt2">
                            <div className="pic-event-instruction">Click on blue arrow to expand list </div>
                                <PicInvitationAttendeeStatus open={panel0IconOpen} handleOnClickForPanel={this.handleOnClickForPanel0} raiseErrorHandler={this.handleRaiseError} 
                                            dataset1={this.state.eventObj}
                                            dataset2={this.state.attendees}
                                />
                                <div className="pic-event-modifier-mt2" />
                                <PicInvitationContribStatus open={panel1IconOpen} handleOnClickForPanel={this.handleOnClickForPanel1} raiseErrorHandler={this.handleRaiseError} 
                                            dataset1={this.state.eventObj}
                                            dataset2={this.state.contributions}
                                />
                                <div className="pic-event-modifier-mt2" />
                                <PicInvitationHelpStatus open={panel2IconOpen} handleOnClickForPanel={this.handleOnClickForPanel2} raiseErrorHandler={this.handleRaiseError} 
                                            dataset1={this.state.eventObj}
                                            dataset2={this.state.helpingHandsList}
                                />
                              
                        </div> 
                    </div>
                    <VisibilityWrapper show={showSkyScraper} contentType="advertisement" >
                        <div className="right-ad-container">
                            <h3 className="ad-web-skyscraper">-- Add Section Skyscraper</h3>
                        </div>
                    </VisibilityWrapper>
                  </div>
               </div>
               {/*<VisibilityWrapper show={showAd} contentType="advertisement" >
                <div className="rc-flex-container-center-hv" style={{borderTop: '1px solid #BDC3C7'}}> 
                    {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                    {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                    {displayAd("web-leader-board", "tablet", {marginTop: '1.5rem', marginBottom: '1.3rem'})}
                </div> 
                        </VisibilityWrapper>*/}
               <Footer />       
                
            </div>
        );
    };
};

const mapDispatchToProps = (dispatch) => ({
    // startLogout:  () => dispatch(startLogout()),
    // // /* used to clear out prior lists from redux store,  before creating new event */
    // // clearActiveEvent:     () => dispatch(clearActiveEvent()),
    // // updateItemList:       (list) => dispatch(updateItemList(list)),
    // // updateParticipants:   (list) => dispatch(updateParticipants(list)),
    // // /* used to clear out application error */
    picAppError:          (errmsg) => dispatch(picAppError(errmsg))
    
})

const mapStateToProps = (state) => {
    return {
        event: state.event,
        auth: state.auth,
        picapp: state.picapp
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PicListStatuses);
// export default connect(mapStateToProps, mapDispatchToProps)(PicInvitation);



// WEBPACK FOOTER //
// ./src/components/PicListStatuses.js